import React from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import existingAccountFolder from '../../../assets/onboarding/existing-account-folder.svg';
import { CENTERED_BAND_MAX_HEIGHT } from '../handoffConstants';

const { Title, Text } = Typography;

/**
 * Screen 2 — terminal state for a lead whose account already exists, either
 * because the email matches an active operation (duplicate) or because the user
 * is known without one. Both arrive as `userPreexisted: true`, and in both cases
 * the only way in is the login: entering straight away would hand out a session
 * for an account this visitor has not proven to own.
 */
const ExistingAccountScreen = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div
			style={{
				flex: 1,
				maxHeight: CENTERED_BAND_MAX_HEIGHT,
				minHeight: 'min-content',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
				padding: 24,
				gap: 48
			}}>
			<img
				src={existingAccountFolder}
				alt=""
				// Shrinks below ~520px of viewport so the artwork doesn't dominate the
				// phone screen; capped at its natural 177px from there up.
				style={{ width: 'min(177px, 34vw)', height: 'auto', objectFit: 'contain' }}
			/>

			<div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 650 }}>
				<Title level={3} style={{ color: '#2F4858', margin: 0, fontWeight: 700 }}>
					{t('handoff.existingAccountTitle', 'Parece que ya tienes una operación con nosotros')}
				</Title>
				<Text style={{ color: '#748EA0' }}>
					{t(
						'handoff.existingAccountDescription',
						'Accede a tu área de hipotecas para continuar. Si ya iniciaste una solicitud anteriormente, podrás verla y seguir avanzando desde tu cuenta.'
					)}
				</Text>
			</div>

			<Button type="primary" onClick={() => navigate('/login')} style={{ width: 250 }}>
				{t('handoff.existingAccountAction', 'Ir al portal de hipotecas')}
			</Button>
		</div>
	);
};

export default ExistingAccountScreen;
